import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
export default new Router({
  routes: [
    {
      name: "",
      path: "/",
      redirect: "/Dashboard"
    },
    {
      path: "/",
      component: () => import("../components/common/Home.vue"),
      // component: () =>
      // import("../pages/xietong/menumanage/menumanage.vue"),
      meta: { title: "运价管理后台" },
      children: [
        {
          name: "home",
          path: "/404",
          component: () =>
            import(/* webpackChunkName: "404" */ "../pages/404.vue"),
          meta: { title: "首页" }
        },
        /*******************************协同***********************/
        {
          name: "rolesmanage",
          path: "rolesmanage/:actionId",
          component: () =>
            import("../pages/xietong/rolesmanage/rolesmanage.vue"),
          meta: {
            title: "用户管理"
          }
        },
        {
          name: "usermanage",
          path: "usermanage/:actionId",
          component: () => import("../pages/xietong/usermanage/usermanage.vue"),
          meta: {
            title: "用户认证"
          }
        },
        {
          name: "menumanage",
          path: "menumanage/:actionId",
          component: () => import("../pages/xietong/menumanage/menumanage.vue"),
          meta: {
            title: "菜单管理"
          }
        },
        {
          name: "roleDefinition",
          path: "roleDefinition/:actionId",
          component: () =>
            import("../pages/xietong/roleDefinition/roleDefinition.vue"),
          meta: {
            title: "角色定义"
          }
        },
        {
          name: "clientprofile",
          path: "clientprofile/:actionId",
          component: () =>
            import("../pages/xietong/clientprofile/clientprofile.vue"),
          meta: {
            title: "系统角色"
          }
        },
        {
          name: "vgmList",
          path: "vgmList/:actionId",
          component: () => import("../pages/xietong/orderhd/orderhd.vue"),
          meta: {
            title: "预配舱单及VGM"
          }
        },
        {
          name: "orderitem",
          path: "orderitem/:actionId",
          component: () => import("../pages/xietong/orderhd/orderitem.vue"),
          meta: {
            title: "预配明细"
          }
        },
        {
          name: "blConfirmList",
          path: "blConfirmList/:actionId",
          component: () =>
            import("../pages/xietong/blConfirmFile/blConfirmList.vue"),
          meta: {
            title: "提单确认列表"
          }
        },
        {
          name: "blConfirmFile",
          path: "blConfirmFile/:actionId",
          component: () =>
            import("../pages/xietong/blConfirmFile/blConfirmFile.vue"),
          meta: {
            title: "提单确认件",
            canMultipleOpen: true
          }
        },
        {
          name: "culImportLog",
          path: "culImportLog",
          component: () =>
            import("../pages/xietong/culImportLog/culImportLog.vue"),
          meta: {
            title: "邮件导入记录查询"
          }
        },
        {
          name: "wharf",
          path: "wharf",
          component: () => import("../pages/xietong/wharf/wharf.vue"),
          meta: {
            title: "码头"
          }
        },
        {
          name: "voyage",
          path: "voyage",
          component: () => import("../pages/xietong/voyage/voyage.vue"),
          meta: {
            title: "船名航次"
          }
        },
        {
          name: "reportquery",
          path: "reportquery",
          component: () =>
            import("../pages/xietong/reportquery/reportquery.vue"),
          meta: {
            title: "报表查询"
          }
        },
        {
          name: "un_blList",
          path: "un_blList/:actionId",
          component: () => import("../pages/xietong/unknown/blList.vue"),
          meta: {
            title: "提单列表"
          }
        },
        {
          name: "blDetail",
          path: "blDetail/:actionId",
          component: () => import("../pages/xietong/unknown/blDetail.vue"),
          meta: {
            title: "提单详情"
          }
        },
        {
          name: "BookingList",
          path: "BookingList/:actionId",
          component: () =>
            import("../pages/xietong/BookingList/BookingList.vue"),
          meta: {
            title: "订舱列表"
          }
        },
        {
          name: "sendList",
          path: "sendList",
          component: () => import("../pages/xietong/sendList/sendList.vue"),
          meta: {
            title: "发送列表"
          }
        },
        {
          name: "soEmailTemplate",
          path: "soEmailTemplate",
          component: () =>
            import("../pages/xietong/soEmailTemplate/templateList.vue"),
          meta: {
            title: "SO邮件模版维护"
          }
        },
        {
          name: "soEmailTemplateDetail",
          path: "soEmailTemplateDetail/:rowid",
          component: () =>
            import("../pages/xietong/soEmailTemplate/templateDetail.vue"),
          meta: {
            title: "SO邮件模版维护"
          }
        },

        {
          name: "BookingListNew",
          path: "BookingListNew/:actionId",
          component: () =>
            import("../pages/xietong/BookingListNew/BookingListNew.vue"),
          meta: {
            title: "订舱列表新"
          }
        },
        {
          name: "un_blListNew",
          path: "un_blListNew/:actionId",
          component: () => import("../pages/xietong/blListNew/blListNew.vue"),
          meta: {
            title: "提单列表新"
          }
        },
        {
          name: "blDetailNew",
          path: "blDetailNew/:actionId",
          component: () => import("../pages/xietong/blListNew/blDetailNew.vue"),
          meta: {
            title: "提单详情"
          }
        },
        {
          name: "blDetailNewStrd",
          path: "blDetailNewStrd/:actionId",
          component: () =>
            import("../pages/xietong/blListNew/blDetailNewStrd.vue"),
          meta: {
            title: "提单详情"
          }
        },
        {
          name: "containerMaster",
          path: "containerMaster",
          component: () =>
            import("../pages/xietong/containerMaster/containerMaster.vue"),
          meta: {
            title: "Container Master"
          }
        },
        {
          name: "customer",
          path: "customer",
          component: () => import("../pages/xietong/customer/customer.vue"),
          meta: {
            title: "Customer"
          }
        },
        {
          name: "si",
          path: "si",
          component: () => import("../pages/xietong/si/si.vue"),
          meta: {
            title: "SI"
          }
        },
        {
          name: "siDetail",
          path: "siDetail/:actionId",
          component: () => import("../pages/xietong/si/siDetail.vue"),
          meta: {
            title: "SI详情"
          }
        },
        {
          name: "uglBookingList",
          path: "uglBookingList",
          component: () =>
            import("../pages/xietong/uglBookingList/uglBookingList.vue"),
          meta: {
            title: "UGL订舱"
          }
        },
        {
          name: "rtsRbsList",
          path: "rtsRbsList",
          component: () => import("../pages/xietong/rtsRbsList/rtsRbsList.vue"),
          meta: {
            title: "RTSRBS"
          }
        }
      ]
    },
    {
      path: "/login",
      component: () => import("../pages/Login.vue"),
      meta: { title: "登录" }
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js